module.exports = __webpack_public_path__ + "static/media/hire-developer.19a66aa9.jpg";